import { Text } from "@aurem/ui";
import { useFormatDate } from "hooks/useFormatDate";
import { ArrowRight } from "lucide-react";
import { CORRECTION_ATTRIBUTE_LABEL_MAP } from "pages/TaskDetails/components/TaskCorrection/constants";
import { useI18n } from "providers/I18nProvider";

type CorrectionItem = {
  attribute: string;
  oldValue: string;
  newValue: string;
};

type Props = {
  corrections: CorrectionItem[];
};

const DATE_ATTRIBUTES = new Set(["dateOfBirth", "startDate", "endDate"]);

const formatValue = (
  attribute: string,
  value: string | null | undefined,
  formatDate: (v: string) => string,
): string => {
  if (!value) return "";
  if (DATE_ATTRIBUTES.has(attribute)) return formatDate(value);
  return value;
};

export const NotificationCorrectionsList = ({ corrections }: Props) => {
  const { t } = useI18n();
  const { formatDate } = useFormatDate();
  const empty = t(
    "apps.admin.pages.taskDetails.correction.employeeDetails.empty",
  );

  return (
    <div className="flex flex-col gap-4 mt-1">
      {corrections.map((c, i) => {
        const oldValue = formatValue(c.attribute, c.oldValue, formatDate);
        const newValue = formatValue(c.attribute, c.newValue, formatDate);

        return (
          <div key={i} className="text-neutral-500">
            <Text size="sm">
              {CORRECTION_ATTRIBUTE_LABEL_MAP[c.attribute]
                ? t(CORRECTION_ATTRIBUTE_LABEL_MAP[c.attribute])
                : c.attribute}
            </Text>
            <div className="flex items-center gap-1">
              {oldValue ? (
                <Text size="sm">{oldValue}</Text>
              ) : (
                <Text size="sm" className="text-neutral-200">
                  {empty}
                </Text>
              )}
              <ArrowRight size="1rem" className="rtl:rotate-180" />
              {newValue ? (
                <Text size="sm">{newValue}</Text>
              ) : (
                <Text size="sm" className="text-neutral-200">
                  {empty}
                </Text>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
